/** Function to update all caches, from CacheProperties.update, with the new data. */
export async function updateCache(storage, data, entries) {
    for (const cacheKey in entries) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const updater = entries[cacheKey];
        if (updater === 'delete') {
            await storage.remove(cacheKey);
            continue;
        }
        const value = await storage.get(cacheKey);
        if (value.state === 'loading') {
            continue;
        }
        const newValue = await updater(value, data);
        if (newValue === 'delete') {
            await storage.remove(cacheKey);
            continue;
        }
        if (newValue !== 'ignore') {
            await storage.set(cacheKey, newValue);
        }
    }
}
